import EfCardIntro from '@elem/ui/ef-card-intro-b';
import EfIcon from '@elem/ui/ef-icon';
import EfTitle from '@elem/ui/ef-title';
import { Fragment } from 'react';
import { useRouter } from 'next/router';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import { PAGE_TYPE } from '../../constants';
import { IPageStatus } from '../../config/IPageStatus';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp({ PRODUCT_BASE, PRODUCT_TM }: any) {
    const { t } = useLang('theProduct.ListA');
    const { t: t2 } = useLang('theProduct.Banner');
    const { pageType, pageStatus } = useProductStore();
    const { locale = 'us' } = useRouter();
    const LINK_MAP: any = {
        us: {
            [PAGE_TYPE.BASE]: {
                moreLink: `https://${locale}.ecoflow.com/products/lithium-12v-100ah-deep-cycle-lifepo4-battery`,
                buyLink: 'https://www.amazon.com/dp/B0DCNBMY5W?maas=maas_adg_20E254DE7A588B8CB17DF397E9B2A90B_afap_abs&ref_=aa_maas&tag=maas',
            },
            [PAGE_TYPE.MOTOR]: {
                moreLink: `https://${locale}.ecoflow.com/products/lithium-12v-100ah-deep-cycle-marine-trolling-motor-battery`,
                buyLink: 'https://www.amazon.com/dp/B0DCNJB1HH?maas=maas_adg_2DDCDB222395C686F308E3B60922171F_afap_abs&ref_=aa_maas&tag=maas',
            },
        },
        ca: {
            [PAGE_TYPE.BASE]: {
                moreLink: 'https://ca.ecoflow.com/products/lithium-12v-100ah-deep-cycle-lifepo4-battery',
                buyLink: 'https://www.amazon.ca/dp/B0DCNBMY5W?maas=maas_adg_4FE9B6A4A44E8697B8B4A21DB41812AD_afap_abs&ref_=aa_maas&tag=maas',
            },
            [PAGE_TYPE.MOTOR]: {
                moreLink: 'https://ca.ecoflow.com/products/lithium-12v-100ah-deep-cycle-marine-trolling-motor-battery',
                buyLink: 'https://www.amazon.ca/dp/B0DCNJB1HH?maas=maas_adg_35AA5F31FF1B6AA53B612EAF508DAA26_afap_abs&ref_=aa_maas&tag=maas',
            },
        },
        au: {
            [PAGE_TYPE.BASE]: {
                moreLink: '',
                buyLink: '',
            },
            [PAGE_TYPE.MOTOR]: {
                moreLink: pageStatus === IPageStatus.statusA ? '' : 'https://au.ecoflow.com/products/ecoflow-12v-100ah-lithium-trolling-motor-battery',
                buyLink: '',
            },
        },
    };
    const LINK = LINK_MAP[locale] || LINK_MAP['us'];
    const EF_ICON_BLACK = 'https://websiteoss.ecoflow.com/upload/image/1722596214571/b1.png';
    const EF_ICON_WHITE = 'https://websiteoss.ecoflow.com/upload/image/1726128856403/icon_ef.png';
    let listA = [
        {
            pc: PRODUCT_TM,
            title: t('a_title'),
            descList: [t('a_desc1'), t('a_desc2'), t('a_desc3')],
            moreText: (
                <>
                    <EfIcon pc={pageType == PAGE_TYPE.BASE ? EF_ICON_WHITE : EF_ICON_BLACK} />
                    {t('btn1')}
                </>
            ),
            moreLink: LINK[PAGE_TYPE.MOTOR].moreLink,
            buyText: (
                <>
                    <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722596226150/b2.png" />
                    {t('btn2')}
                </>
            ),
            buyLink: LINK[PAGE_TYPE.MOTOR].buyLink,
            gtm_buy: {
                event: 'uaEvent',
                event_name: 'buy_on_amazon',
                product_name: t('a_title'),
                button_name: t('btn2'),
                list_name: t('title'),
            },
        },
        {
            pc: PRODUCT_BASE,
            title: t('b_title'),
            descList: [t('b_desc1'), t('b_desc2'), t('b_desc3')],
            moreText: (
                <>
                    <EfIcon pc={pageType == PAGE_TYPE.BASE ? EF_ICON_WHITE : EF_ICON_BLACK} />
                    {t('btn1')}
                </>
            ),
            moreLink: LINK[PAGE_TYPE.BASE].moreLink,
            buyText: (
                <>
                    <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722596226150/b2.png" />
                    {t('btn2')}
                </>
            ),
            buyLink: LINK[PAGE_TYPE.BASE].buyLink,
            gtm_buy: {
                event: 'uaEvent',
                event_name: 'buy_on_amazon',
                product_name: t('b_title'),
                button_name: t('btn2'),
                list_name: t('title'),
            },
        },
    ];
    if (locale == 'au') {
        listA = [
            {
                pc: PRODUCT_TM,
                title: t('a_title'),
                descList: [t('a_desc1'), t('a_desc2'), t('a_desc3'), t('a_desc4')],
                moreText: (
                    <>
                        <EfIcon pc={pageType == PAGE_TYPE.BASE ? EF_ICON_WHITE : EF_ICON_BLACK} />
                        {t('btn1')}
                    </>
                ),
                moreLink: LINK[PAGE_TYPE.MOTOR].moreLink,
                buyText: (
                    <>
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722596226150/b2.png" />
                        {t('btn2')}
                    </>
                ),
                buyLink: LINK[PAGE_TYPE.MOTOR].buyLink,
                gtm_buy: {
                    event: 'uaEvent',
                    event_name: 'buy_on_amazon',
                    product_name: t('a_title'),
                    button_name: t('btn2'),
                    list_name: t('title'),
                },
            },
        ];
    }
    if (locale === 'br') {
        listA = [
            {
                pc: PRODUCT_TM,
                title: t('a_title'),
                descList: [t('a_desc1'), t('a_desc2'), t('a_desc3')],
                moreText: (
                    <>
                        <EfIcon pc={pageType == PAGE_TYPE.BASE ? EF_ICON_WHITE : EF_ICON_BLACK} />
                        {t('btn1')}
                    </>
                ),
                moreLink: 'https://br.ecoflow.com/products/ecoflow-12v-100ah-lithium-trolling-motor-battery',
                buyText: (
                    <>
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722596226150/b2.png" />
                        {t('btn2')}
                    </>
                ),
                buyLink: '',
                gtm_buy: {
                    event: 'uaEvent',
                    event_name: 'buy_on_amazon',
                    product_name: t('a_title'),
                    button_name: t('btn2'),
                    list_name: t('title'),
                },
            },
        ];
    }
    if (locale === 'mx') {
        listA = [
            {
                pc: PRODUCT_TM,
                title: t('a_title'),
                descList: [t('a_desc1'), t('a_desc2'), t('a_desc3')],
                moreText: (
                    <>
                        <EfIcon pc={pageType == PAGE_TYPE.BASE ? EF_ICON_WHITE : EF_ICON_BLACK} />
                        {t('btn1')}
                    </>
                ),
                moreLink: 'https://mx.ecoflow.com/products/ecoflow-12v-100ah-lithium-trolling-motor-battery',
                buyText: (
                    <>
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722596226150/b2.png" />
                        {t('btn2')}
                    </>
                ),
                buyLink: '',
                gtm_buy: {
                    event: 'uaEvent',
                    event_name: 'buy_on_amazon',
                    product_name: t('a_title'),
                    button_name: t('btn2'),
                    list_name: t('title'),
                },
            },
        ];
    }

    return (
        <div className={styles.TheComp2}>
            <EfTitle theme={pageType == PAGE_TYPE.BASE ? 'black' : 'white'}>{t('title')}</EfTitle>
            <div className="ef-container ListA-list">
                {listA.map((item: any, index: number) => (
                    <Fragment key={index}>
                        <EfCardIntro {...item} gtm_position={t2('title')} theme={pageType == PAGE_TYPE.BASE ? 'black' : 'white'} />
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
